import React, { useEffect, useState } from "react";
import { useSeasonsStore } from "../../store/seasonsStore";
import { Busy } from "../../components/Busy";
import { ScheduleCard } from "../../components/public/schedule/ScheduleCard";
import { ScheduleTable } from "../../components/public/schedule/ScheduleTable";
import { Heading } from "../../components/catalyst/heading";
import "./Schedule.css";
import { useMatchesStore } from "../../store/matchesStore";
import useAuthStore from "../../store/authStore";
import SetupPlayersForMatch from "./SetupPlayersForMatch";
import { useTeamsStore } from "../../store/teamsStore";

const Matches: React.FC = () => {
  const { currentSeason, getCurrentSeason, isBusy } = useSeasonsStore();
  const { allMatches, loadAllMatchesForTeam, saveSelectedPlayersForMatch } =
    useMatchesStore();
  const { teamDetailsForSelection, getTeamDetailsForPlayerSelection } =
    useTeamsStore();
  const { currentUser } = useAuthStore();
  const [showMatchSetup, setShowMatchSetup] = useState(false);
  const [selectedEntry, setSelectedEntry] = useState<any>(null);
  const [selectedMatchConfig, setSelectedMatchConfig] = useState<any>(null);
  const [currentTeamId, setCurrentTeamId] = useState<string | null>(null);

  useEffect(() => {
    getCurrentSeason();
  }, [getCurrentSeason]);

  const [formattedData, setFormattedData] = useState<any[]>([]);

  const fetchAllMatches = async () => {
    if (currentSeason && currentUser) {
      let teamId = "";
      if (currentUser.isOwner) {
        teamId = currentUser.ownerForTeamId ?? "";
      } else if (currentUser.isCaptain) {
        teamId = currentUser.captainForTeamId ?? "";
      }

      if (teamId) {
        setCurrentTeamId(teamId);
        loadAllMatchesForTeam(currentSeason.id, teamId);
      }
    }
  };

  useEffect(() => {
    if (!currentSeason) {
      return;
    }
    fetchAllMatches();

    const data = currentSeason.seasonMatches;
    const formattedData = data.map((entry, index) => {
      const isFinals = entry.matchType.includes("FINALS");
      const isFirstInStage =
        index === 0 ||
        data[index - 1].groupOrKnockout !== entry.groupOrKnockout;
      const stageRowspan = isFirstInStage
        ? data.filter((e) => e.groupOrKnockout === entry.groupOrKnockout).length
        : undefined;
      return {
        ...entry,
        isFirstInStage,
        stageRowspan,
        isFinals,
      };
    });
    setFormattedData(formattedData);
  }, [currentSeason, currentUser]);

  const handleMatchSetup = (entry: any) => {
    if (allMatches && allMatches.length > 0) {
      const match = allMatches.find((m) => m.matchId === entry.id);
      if (match && match.allowPlayerSelections) {
        setSelectedEntry(entry);
        setSelectedMatchConfig(match);
        setShowMatchSetup(true);
        if (currentTeamId) {
          getTeamDetailsForPlayerSelection(currentTeamId, match.matchId);
        }
      }
    }
  };
  const haColl = () => {
    if (selectedMatchConfig && currentTeamId) {
      const holeAllocation = selectedMatchConfig.holeAllocation?.find(
        (allocation: any) => allocation.teamId === currentTeamId
      );
      if (holeAllocation) {
        return holeAllocation.holes;
      }
    }
    return [];
  };

  const savePlayersSelections = async (players: any) => {
    if (selectedMatchConfig && selectedEntry) {
      await saveSelectedPlayersForMatch(selectedEntry.id, players);
      fetchAllMatches();
      setShowMatchSetup(false);
    }
  };
  const cancelMatchSetup = () => {
    setSelectedEntry(null);
    setSelectedMatchConfig(null);
    setShowMatchSetup(false);
  };

  return (
    <div className="py-3 px-2 pb-6">
      {showMatchSetup && (
        <SetupPlayersForMatch
          team={teamDetailsForSelection ?? undefined}
          availableHoles={haColl()}
          matchConfig={selectedMatchConfig}
          entry={selectedEntry}
          courseConfig={currentSeason?.courseConfigs.find(
            (c) => c.courseName === selectedMatchConfig.courseName
          )}
          savePlayersSelections={savePlayersSelections}
          onCancel={cancelMatchSetup}
        />
      )}
      {!showMatchSetup && (
        <>
          <Heading>Game Schedule</Heading>
          <div className="schedule-view">
            {currentSeason &&
              currentSeason.seasonMatches &&
              currentSeason.seasonMatches.length > 0 && (
                <>
                  <div className="desktop-view">
                    <ScheduleTable
                      data={formattedData}
                      onMatchSetup={handleMatchSetup}
                    />
                  </div>
                  <div className="mobile-view">
                    {formattedData.map((entry) => (
                      <ScheduleCard
                        key={entry.id}
                        entry={entry}
                        onMatchSetup={handleMatchSetup}
                      />
                    ))}
                  </div>
                </>
              )}
          </div>
        </>
      )}
      {isBusy && <Busy busyMessage={"Please wait..."} />}
    </div>
  );
};

export default Matches;
